import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { BasicError, err, isHttpError, ok } from "@nju/result";
import { serverResponse } from "./validators";

interface IActivatePromoCodeProps {
  targetUserId: string | undefined;
  subId: string | undefined;
  codeId: string;
}

export async function activatePromoCode({
  targetUserId,
  codeId,
  subId,
}: IActivatePromoCodeProps) {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/simpleProductOrder`,
    {
      method: "post",
      validator: serverResponse,
      headers: {
        "Accept-Language": "pl",
        "Client-Id": process.env.NEXT_PUBLIC_CLIENT_ID || "unknown",
      },
      json: {
        targetUserId,
        subId,
        codeId,
      },
    },
  );

  if (result.isError) {
    Bugsnag.notify(result.err);

    if (isHttpError(result.err) && result.err.status === 409) {
      return err(
        new BasicError({
          code: "409_CONFLICT",
          message: "This product order is already pending",
        }),
      );
    }

    return result;
  }

  return ok(undefined);
}
